import PostFeed from "./post-feed";
import { h, render } from "preact";

class SectionBlogPostFeed extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.container = this.querySelector("[data-container]");
    render(<PostFeed data={this.data} />, this.container);
  }
}

if (!customElements.get("section-blog-post-feed")) {
  customElements.define("section-blog-post-feed", SectionBlogPostFeed);
}
